import { defineMessages } from 'react-intl';

const messages = defineMessages({
  submitButton: {
    id: 'App.CompleteRenewalCheck.submitButton',
    defaultMessage: 'Complete Renewal'
  }
});

export default messages;
